import React, { useState, useEffect, useRef, useContext } from "react";
import { baseRequest } from "../../../axiosconfig";
import { ROLES } from "../../../constants/roles";
import DropDown from "../../elements/dropDown";
import AdminFormulariRizikaList from "../adminFormulariRizikaList";
import { formatDesignations, formatProcesses } from "../../mapeProcesa";
import MapeProcesaList from "../mapeProcesaList";
import Loading from "../../loading";
import { useNavigate } from "react-router-dom";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { PRINT_PAGE_STYLE } from "../../../utils/printPageStyle";
import MapaProcesaListPrint from "./mapaListPrint";
import { UserContext } from "../../../userContext";
import DeleteMapaPopup from "../../deleteMapaPopup";

function AdminMapeProcesa(props) {
  const orgUnitsDropdownstyle = {
    borderRight: "1px solid var(--mainColor)",
    width: "50%",
  };
  const processesDropdownStyle = {
    borderRight: "1px solid var(--mainColor)",
    width: "30%",
  };
  const [showDropdown, setShowDropdown] = useState(false);
  const [organizationUnits, setOrganizationUnits] = useState([]);
  const [orgUnits, setOrgUnits] = useState([]);
  const [activeUnit, setActiveUnit] = useState({
    id: "all",
    name: "Sve organizacione jedinice",
  });
  const [activeProcess, setActiveProcess] = useState({
    id: "all",
    name: "Svi procesi",
  });
  const [activeSort, setActiveSort] = useState({
    id: "date_desc",
    name: "Datum (najnovije)",
  });
  const [designations, setDesignations] = useState();
  const [designationsList, setDesignationsList] = useState();
  const [processes, setProcesses] = useState();
  const [mapaList, setMapaList] = useState();
  const [mapa, setMapa] = useState();
  const [designationsCopy, setDesignationsCopy] = useState();
  const [enableEdit, setEnableEdit] = useState(false);
  const [filteredMaps, setFilteredMaps] = useState();
  const [selectedProcess, setSelectedProcess] = useState();
  const [loading, setLoading] = useState(false);
  const [mapaToDelete, setMapaToDelete] = useState();

  const handleSelectUnit = ({ value }) => {
    setActiveUnit(value);
    setActiveProcess({ id: "all", name: "Svi procesi" });
  };

  const calculateProcess = (id, list) => {
    const process = list.find((proc) => {
      return proc.id === id && !proc.del;
    });

    return process;
  };

  const navigate = useNavigate();

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: PRINT_PAGE_STYLE,
  });

  const { user } = useContext(UserContext);

  useEffect(() => {
    setLoading(true);
    const urls = [
      "/organization_unit/0",
      "/employee/id/0/level/0",
      "/designations/0/0",
      "/business_processes",
      "/process_maps",
    ];

    Promise.all(
      urls.map((url) => baseRequest.get(url))
    )
      .then((res) => {
        const [unitsRes, employeesRes, designationsRes, processesRes, mapsRes] = res;
        const responseObj = {
          organization_units: unitsRes.data.data || [],
          designations: formatDesignations(employeesRes.data.data || []),
          designationsList: designationsRes.data.designations || [],
          business_processes: processesRes.data.business_processes || [],
          process_maps: mapsRes.data.process_maps || [],
        };

        setOrganizationUnits(
          responseObj["business_processes"].filter(
            (el) => !el.del && el.organization_unit_id !== 0
          )
        );
        setOrgUnits(
          (responseObj["organization_units"] || []).filter(
            (u) => !u.del && u.id !== 0
          )
        );
        setDesignations(responseObj["designations"]);

        setProcesses(formatProcesses(responseObj["business_processes"]));
        setDesignationsList(responseObj["designationsList"]);

        const actualMapas = responseObj["process_maps"].filter(
          (mapa) =>
            mapa.business_process_list_id !== null &&
            !mapa.del &&
            !mapa.is_archived
        );

        const mapasWithProcess = actualMapas
          .map((mapa) => {
            const process = calculateProcess(
              mapa.business_process_list_id,
              formatProcesses(responseObj["business_processes"])
            );
            if (process) {
              return {
                ...mapa,
                process: process,
              };
            } else {
              return undefined;
            }
          })
          .filter((item) => item);

        setMapaList(mapasWithProcess);

        const firstMapa = mapasWithProcess[0];
        setMapa(firstMapa);

        setLoading(false);
      })
      .catch((error) => {

        setLoading(false);
      });
  }, []);

  // Zapis mape nastaje tek na „Sačuvajte mapu procesa“ — „+“ samo otvara novu mapu
  const addNewMapa = () => {
    navigate("/admin/mape-procesa/new");
  };

  const filterProcesses = (unit, proc) => {
    if (unit.id === "all") return proc;
    return proc.filter(
      (p) => p.organization_unit_id === unit.id && p.level === unit.level
    );
  };

  const filterMaps = (list, unit, process, sort) => {
    let filtered = list;
    if (unit.id !== "all") {
      filtered = filtered.filter(
        (m) =>
          m.process?.organization_unit_id === unit.id &&
          m.process?.level === unit.level
      );
    }
    if (process && process.id !== "all") {
      filtered = filtered.filter(
        (m) => m.business_process_list_id === process.id
      );
    }
    if (sort) {
      const sorted = [...filtered];
      if (sort.id === "date_desc") {
        sorted.sort(
          (a, b) =>
            new Date(b.created_at || 0) - new Date(a.created_at || 0)
        );
      } else if (sort.id === "date_asc") {
        sorted.sort(
          (a, b) =>
            new Date(a.created_at || 0) - new Date(b.created_at || 0)
        );
      } else if (sort.id === "name_asc") {
        sorted.sort((a, b) =>
          (a.process?.name || "").localeCompare(b.process?.name || "")
        );
      } else if (sort.id === "name_desc") {
        sorted.sort((a, b) =>
          (b.process?.name || "").localeCompare(a.process?.name || "")
        );
      }
      return sorted;
    }
    return filtered;
  };

  const sortOptions = [
    { id: "date_desc", name: "Datum (najnovije)" },
    { id: "date_asc", name: "Datum (najstarije)" },
    { id: "name_asc", name: "Naziv (A–Š)" },
    { id: "name_desc", name: "Naziv (Š–A)" },
  ];

  const selectProcess = ({ value }) => {
    setActiveProcess(value);
  };

  const canAddMapa = (user, mapas, processList) => {
    if (user.role_id === ROLES.SUPER_ADMIN) {
      if (!processList.length) {
        return false;
      } else if (!mapas.length && processList.length) {
        return true;
      } else if (mapas.length && processList.length) {
        const result = processList.filter((process) => {
          const matchedMapa = mapas.find((mapa) => {
            return (
              mapa.process.business_process_id ===
                process.business_process_id && mapa.process.id === process.id
            );
          });
          return matchedMapa;
        });
        let difference = processList.filter(
          (process) => !result.find((item) => item.id === process.id)
        );
        if (difference.length) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      const userMapas = mapas.filter(
        (el) =>
          el.process.organization_unit_id === user.organization_unit_id &&
          el.process.level === user.level
      );

      const userProcesses = processList.filter(
        (proc) =>
          proc.organization_unit_id === user.organization_unit_id &&
          proc.level === user.level
      );

      if (!userProcesses.length) {
        return false;
      } else if (!userMapas.length && userProcesses.length) {
        return true;
      } else if (userMapas.length && userProcesses.length) {
        const result = userProcesses.filter((process) => {
          const matchedMapa = userMapas.find((mapa) => {
            return mapa.process.id === process.id;
          });
          return matchedMapa;
        });
        let difference = userProcesses.filter(
          (process) => !result.find((item) => item.id === process.id)
        );

        if (difference.length) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const HandleDeleteMapa = () => {
    setLoading(true);
    baseRequest
      .delete(`/process_map/${mapaToDelete.id}`)
      .then((res) => {
        setLoading(false);
        setMapaToDelete(null);
        setMapaList((list) => {
          const newMapas = list.filter((mapa) => mapa.id !== res.data.data.id);
          return newMapas;
        });
      })
      .catch((error) => {
        setLoading(false);

      });
  };

  return (
    <div>
      <div className="processes-header">
        <DropDown
          dropDownStyle={orgUnitsDropdownstyle}
          height={"49px"}
          list={orgUnits}
          onChange={handleSelectUnit}
          selectedValue={activeUnit?.name}
          isFilter={true}
          allLabel={"Sve organizacione jedinice"}
          placeholder={"Organizaciona jedinica"}
        />
        <DropDown
          dropDownStyle={processesDropdownStyle}
          height={"49px"}
          list={
            processes && activeUnit
              ? filterProcesses(activeUnit, processes)
              : []
          }
          onChange={selectProcess}
          selectedValue={activeProcess?.name}
          isFilter={true}
          allLabel={"Svi procesi"}
          placeholder={"Naziv procesa"}
        />
        <DropDown
          dropDownStyle={{ borderRight: "1px solid var(--mainColor)", width: "20%" }}
          height={"49px"}
          list={sortOptions}
          onChange={({ value }) => setActiveSort(value)}
          selectedValue={activeSort?.name}
          placeholder={"Sortiraj po"}
        />

        {/* <div className="sort-options-dropdown" style={{ flex: 1 }}>
          <div
            className="sort-options-dropdown-selected"
            onClick={() => {
              setShowDropdown((state) => !state);
            }}
          >
            <span style={{ marginRight: "7px", paddingLeft: "10px" }}>
              Opcije
            </span>

            <img
              alt=""
              src="/images/sidebararrow.png"
              className="sidebar-navigation-item-arrow"
            ></img>
          </div>
          {showDropdown && (
            <ul
              className="sort-options-dropdown-options"
              style={{ left: "0", zIndex: "100", flex: 1 }}
            >
              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  setShowDropdown(false);
                }}
              >
                Izmenite
              </li>

              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  handlePrint();
                }}
              >
                Odštampaj
              </li>
            </ul>
          )}
        </div> */}
        <div style={{ marginRight: "10px", marginLeft: "10px" }}>
          {user && mapaList && (
            <button className="add-btn-large" onClick={handlePrint}>
              <img alt="" src="/images/printer.png"></img>
            </button>
          )}
        </div>
        {user &&
          mapaList &&
          processes &&
          canAddMapa(user, mapaList, processes) && (
            <div>
              <button className="add-btn-large" onClick={addNewMapa}>
                <img alt="" src="/images/plus.png"></img>
              </button>
            </div>
          )}
      </div>
      {mapaList && (
        <MapeProcesaList
          activeUnit={activeUnit}
          list={filterMaps(mapaList, activeUnit, activeProcess, activeSort)}
          setMapaToDelete={setMapaToDelete}
        />
      )}

      {mapaList && (
        <div style={{ display: "none" }}>
          <MapaProcesaListPrint
            ref={componentRef}
            list={filterMaps(mapaList, activeUnit, activeProcess, activeSort)}
          />
        </div>
      )}
      {mapaToDelete && (
        <div className="loading">
          <DeleteMapaPopup
            setItemToDelete={setMapaToDelete}
            loading={loading}
            handleItemDelete={HandleDeleteMapa}
          />
        </div>
      )}

      <Loading isLoading={loading} />
    </div>
  );
}

export default AdminMapeProcesa;
